import { NgModule } from '@angular/core';

import { IgoAppMeasurerToolModule } from './measurer-tool/measurer-tool.module';

@NgModule({
  imports: [],
  declarations: [],
  exports: [
    IgoAppMeasurerToolModule
  ]
})
export class IgoAppMeasureModule {}
